import React, { useEffect, useState } from 'react';
import { api } from '../api';
import { useApp } from '../context/AppContext';

export default function Departments() {
  const { toast } = useApp();
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ name: '', code: '' });
  const [editId, setEditId] = useState(null);

  const load = () => api.getDepartments().then(d => { setDepartments(d); setLoading(false); });
  useEffect(() => { load(); }, []);

  const openAdd = () => { setForm({ name: '', code: '' }); setEditId(null); setModal('form'); };
  const openEdit = (d) => { setForm({ name: d.name, code: d.code }); setEditId(d.id); setModal('form'); };

  const handleSave = async () => {
    if (!form.name || !form.code) return toast('Name and code are required', 'error');
    try {
      if (editId) {
        await api.updateDepartment(editId, form);
        toast('Department updated');
      } else {
        await api.createDepartment(form);
        toast('Department created');
      }
      setModal(null);
      load();
    } catch (e) {
      toast(e.message, 'error');
    }
  };

  const handleDelete = async (dept) => {
    if (!window.confirm(`Delete "${dept.name}"? This only works if no employees are assigned.`)) return;
    try {
      await api.deleteDepartment(dept.id);
      toast('Department deleted');
      load();
    } catch (e) {
      toast(e.message, 'error');
    }
  };

  return (
    <div className="page-body">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <button className="btn btn-primary" onClick={openAdd}>+ New Department</button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Department Name</th>
                <th>Code</th>
                <th>Employees</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={5}><div className="loading-center"><span className="spinner" /></div></td></tr>
              ) : departments.map(dept => (
                <tr key={dept.id}>
                  <td style={{ color: 'var(--iocl-white)', fontWeight: 500 }}>{dept.name}</td>
                  <td><span className="badge badge-orange">{dept.code}</span></td>
                  <td><span className="badge badge-blue">{dept.employee_count}</span></td>
                  <td style={{ color: 'var(--iocl-muted)' }}>{dept.created_at?.split(' ')[0]}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-secondary btn-sm" onClick={() => openEdit(dept)}>Edit</button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(dept)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {modal === 'form' && (
        <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setModal(null)}>
          <div className="modal">
            <div className="modal-header">
              <h3 className="modal-title">{editId ? 'Edit Department' : 'New Department'}</h3>
              <button className="btn btn-secondary btn-sm btn-icon" onClick={() => setModal(null)}>✕</button>
            </div>
            <div className="form-group">
              <label>Department Name *</label>
              <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="e.g. Finance" />
            </div>
            <div className="form-group">
              <label>Short Code *</label>
              <input value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value.toUpperCase() }))} placeholder="e.g. FIN" maxLength={10} />
            </div>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setModal(null)}>Cancel</button>
              <button className="btn btn-primary" onClick={handleSave}>{editId ? 'Save' : 'Create'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
